"use client";

import type { ShellTransientWindows } from "@smartmanager/shell-ui/host";

import { isEphemeralComponentName } from "@/src/features/windows/ephemeralComponents";
import { useAppStore } from "@/src/state/appStore";

/**
 * Session-only windows on the app's grid. The store already keeps ephemeral
 * component names out of saved and synced workspaces; closing one also skips
 * the deleted-component ledger, so nothing about it outlives the session.
 */
export const shellTransientWindows: ShellTransientWindows = {
  show: ({ id, name, size, props, reason }, options = {}) => {
    if (!isEphemeralComponentName(name)) {
      throw new Error(`${name} is saved with the workspace, so it cannot open as a session-only window.`);
    }
    useAppStore.getState().addComponentToGrid([
      {
        id,
        priority: "High",
        size,
        name,
        props,
        group: "System",
        score: 10,
        reason,
        createdDate: Date.now(),
      },
    ], undefined, { targetWindowId: options.targetWindowId });
  },
  close: (ids, options = {}) => {
    useAppStore.getState().removeComponent([...ids], false, {
      targetWindowId: options.targetWindowId,
      skipPersistence: true,
      skipSync: true,
      trackDeleted: false,
    });
  },
};
